var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../UnlinkedApplicationForm";
import { Button, Checkbox } from "@savvyinsure/react-ui";
import { PivotReason } from "../../features/applicant/applicantSlice";
import useAppSelector from "../../hooks/useAppSelector";
import { useFormContext } from "react-hook-form";
export var ApplicableDiscount;
(function (ApplicableDiscount) {
    ApplicableDiscount["EMPLOYED_FULL_TIME"] = "isEmployedFullTime";
    ApplicableDiscount["MARRIED"] = "isMarried";
    ApplicableDiscount["HOMEOWNER"] = "isHomeowner";
    ApplicableDiscount["STUDENT"] = "isStudent";
    ApplicableDiscount["BACHELORS_DEGREE"] = "hasBachelorsDegree";
    ApplicableDiscount["MILITARY"] = "isMilitary";
})(ApplicableDiscount || (ApplicableDiscount = {}));
var discountsOptions = [
    { key: ApplicableDiscount.EMPLOYED_FULL_TIME, label: "Employed full time" },
    { key: ApplicableDiscount.MARRIED, label: "Married" },
    { key: ApplicableDiscount.HOMEOWNER, label: "Homeowner" },
    { key: ApplicableDiscount.STUDENT, label: "Student" },
    {
        key: ApplicableDiscount.BACHELORS_DEGREE,
        label: "Bachelor's degree or higher",
    },
    {
        key: ApplicableDiscount.MILITARY,
        label: "Honorably served in U.S. military",
    },
];
export default function ApplicableDiscountsForm(_a) {
    var _b = _a.isPolicyHolder, isPolicyHolder = _b === void 0 ? true : _b, onSubmit = _a.onSubmit;
    var register = useFormContext().register;
    var isBundleAutoFromHome = useAppSelector(function (state) {
        return state.applicant.bundlePivotReason === PivotReason.BundleAutoFromHome;
    });
    var filteredOptions = discountsOptions.filter(function (option) { return option.key !== ApplicableDiscount.MILITARY; });
    return (React.createElement("form", { className: "pb-6", onSubmit: onSubmit },
        React.createElement("div", { className: "mb-4 flex-none pt-4" },
            React.createElement(UnlinkedApplicationForm.Header, null, isPolicyHolder
                ? "Do you qualify for any of these discounts?"
                : "Does the person you're married to qualify for any of these discounts?")),
        React.createElement("div", { className: "flex grow flex-col space-y-4" },
            React.createElement("div", { className: "flex-none space-y-3" }, filteredOptions.map(function (discount) { return (React.createElement(Checkbox, __assign({ contained: true, key: discount.key, label: discount.label, disabled: discount.key === ApplicableDiscount.HOMEOWNER &&
                    isBundleAutoFromHome }, register(discount.key)))); }))),
        React.createElement("div", { className: "mt-4" },
            React.createElement(Button, null, "Continue"))));
}
